import { createContext } from '@lit/context';

export type ChatbotMessageContext = {
    conversationId?: string;
    messageId?: string;
    apiUrl?: string;
    score?: number;
};

export const chatbotMessageContext = createContext<ChatbotMessageContext>(Symbol('lr-chatbot-message-context'));
